import styled from "@xstyled/styled-components";
import { useNavigate } from "react-router-dom";

import { palette, pxToRem } from "@otta/design-tokens";
import { IconList, IconListItem } from "@hire/components/IconList";
import { Button, Heading, Spacing, theme } from "@otta/design";
import { ResponsiveButtonContainer } from "@hire/components/ResponsiveButtonContainer";
import { LogoHeader } from "@hire/components/layout/QuizLayout";

const Main = styled.main`
  background-color: ${palette.brand.white};
  flex-direction: column;
  min-height: 100vh;
  min-width: 100vw;
  display: flex;
`;

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  width: ${pxToRem(1200)};
  max-width: 100%;
  margin: 0 auto;
`;

const Content = styled.div`
  max-width: ${pxToRem(800)};
`;

export function WhoIsStartupFor() {
  const navigate = useNavigate();

  const handleContinue = () => {
    navigate("/quiz/about-wttj");
  };

  return (
    <Main>
      <LogoHeader />
      <PageContainer>
        <Spacing size={2}>
          <Heading size={3} bold align="center">
            Who is the startups plan for, and is it right for your business?
          </Heading>
          <Content>
            <IconList>
              <IconListItem icon="checkmark">
                You're a small business with under 50 employees, and have
                between 1-3 roles to fill
              </IconListItem>
              <IconListItem icon="checkmark">
                You need quality inbound applications sent directly to your ATS,
                or directly in the platform
              </IconListItem>
              <IconListItem icon="checkmark">
                You're not worried about maximum visibility, but you want to
                promote your company profile and roles to great candidates
              </IconListItem>
              <IconListItem icon="checkmark">
                You don't have very senior or technical roles to fill that
                require sourcing or enhanced employer branding content
              </IconListItem>
              <IconListItem icon="checkmark">
                You want to self-serve and manage your page and jobs without
                expert guidance from our in-house recruitment specialists
                (CSM's)
              </IconListItem>
              <IconListItem icon="checkmark">
                You're happy to invest a bit of time crafting a strong company
                profile to help candidates make informed, smart decisions about
                which jobs to apply to
              </IconListItem>
              <IconListItem icon="checkmark">
                You need flexibility on pricing as your hiring fluctuates
                rapidly
              </IconListItem>
            </IconList>
          </Content>
          <ResponsiveButtonContainer breakpoint={theme.screens.desktop}>
            <Spacing size={-1.5}>
              <Button
                onClick={handleContinue}
                level="primary"
                data-analytics-id="who-is-startups-for-continue"
              >
                Continue
              </Button>
            </Spacing>
          </ResponsiveButtonContainer>
        </Spacing>
      </PageContainer>
    </Main>
  );
}
